import { Box, BoxProps } from '@material-ui/core';
import React from 'react';

import { useCustomTheme } from '@/hooks/useCustomTheme';

import { Font } from './Font';
import { Icon } from './Icon';
import { MoreActionsMenuWithIcon } from './MoreActionsMenu/MoreActionsMenuWithIcon';
import { ActionsOption } from './MoreActionsMenu/types/ActionsOption';
import { StyledTooltip } from './StyledTooltip';
import { Text } from './Text';

export interface SubSectionWrapperProps extends BoxProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  titleTooltip?: string;
  dynamicDataTexts?: string[];
  leftComponent?: React.ReactNode;
  rightComponent?: React.ReactNode;
  toggleEditModeDialog?: () => void;
  specificActionsOptionsArray?: ActionsOption[];
}

export const SubSectionWrapper = ({
  children,
  title,
  subtitle,
  titleTooltip,
  dynamicDataTexts,
  leftComponent,
  rightComponent,
  toggleEditModeDialog,
  specificActionsOptionsArray,
  ...props
}: SubSectionWrapperProps) => {
  const { palette } = useCustomTheme();

  const editInformationOption: ActionsOption[] | undefined = toggleEditModeDialog
    ? [
        {
          display: <Text tId={'EDIT_INFORMATION'} />,
          onClick: toggleEditModeDialog,
          iconName: 'edit',
        },
      ]
    : undefined;

  const moreActionsOptionsArray = specificActionsOptionsArray ? specificActionsOptionsArray : editInformationOption;

  return (
    <Box display="flex" flexDirection="column" position="relative" width="100%" {...props}>
      <Box pb={1} my={title ? 2 : 0} display="inline-flex" justifyContent="space-between" width="100%">
        <Box display="flex" flexDirection="column">
          {title && (
            <Box display="flex" alignItems="center">
              <Font variant="h4" color="textPrimary">
                <Text strong tId={title} dynamicDataTexts={dynamicDataTexts} />
              </Font>
              {titleTooltip && (
                <Box display="flex" ml={1} lineHeight={0}>
                  <StyledTooltip title={<Text tId={titleTooltip} />} tooltipProps={{ placement: 'top' }}>
                    <Box display="flex" lineHeight={0}>
                      <Icon size={16} color={palette.grey[400]}>
                        info
                      </Icon>
                    </Box>
                  </StyledTooltip>
                </Box>
              )}
            </Box>
          )}
          {subtitle && (
            <Box>
              <Font variant="caption" color="textSecondary">
                <Text tId={subtitle} />
              </Font>
            </Box>
          )}
        </Box>
        <Box display="inline-flex" alignItems="center">
          {!!leftComponent && leftComponent}
          {moreActionsOptionsArray && <MoreActionsMenuWithIcon actionsOptionsArray={moreActionsOptionsArray} />}
          {!!rightComponent && rightComponent}
        </Box>
      </Box>
      {children}
    </Box>
  );
};
